{
	"actions": {
		"cancel": "Cancel",
		"delete": "Delete group",
		"open": "Open group",
		"open_menu": "Open actions menu"
	},
	"add_members": {
		"added_one": "{{count}} member added to «{{name}}».",
		"added_other": "{{count}} members added to «{{name}}».",
		"already": "Already a member",
		"cap_hint": "You can add up to {{max}} at a time.",
		"description_created": "Group created. Now add the people who will be in it.",
		"failed_description": "One or more people are no longer active in the organization. Remove them from the list and try again.",
		"failed_title": "Nobody was added.",
		"pending": "Adding…",
		"picker_empty": "No people found.",
		"picker_label": "People to add",
		"placeholder": "Search by name or email",
		"selected_one": "{{count}} selected",
		"selected_other": "{{count}} selected",
		"skip": "Later",
		"submit": "Add",
		"title": "Add members"
	},
	"columns": {
		"actions": "Actions",
		"members": "Members",
		"name": "Name",
		"visibility": "Visibility"
	},
	"delete": {
		"confirm": "Delete group",
		"description": "Members will lose access to the files shared with the group. This cannot be undone.",
		"pending": "Deleting…",
		"title": "Delete «{{name}}»?"
	},
	"detail": {
		"not_found_action": "Back to groups",
		"not_found_description": "It may have been deleted. Go back to the list to find what you are looking for.",
		"not_found_title": "This group no longer exists",
		"tab_members": "Members",
		"tab_settings": "Settings",
		"unavailable_description": "It may have been deleted, or it is private and you are not a member.",
		"unavailable_title": "This group is not available"
	},
	"empty": {
		"first_description": "With a group you share files and folders with a whole team in one step. Whoever joins the group later gets access on their own.",
		"first_title": "No groups yet",
		"mine_action": "Show all groups",
		"mine_description": "The groups you are a member of show up here.",
		"mine_title": "You are not in any group",
		"search_description": "Try another word, or <create>create the group «{{q}}»</create>.",
		"search_hint": "Try another word.",
		"search_title": "No group contains «{{q}}»"
	},
	"leave": {
		"action": "Leave group",
		"confirm": "Leave",
		"description": "You will lose access to the files shared with the group.",
		"description_manager": "You will lose access to the files shared with the group and will no longer manage it.",
		"left": "You are no longer in «{{group}}».",
		"pending": "Leaving…",
		"title": "Leave «{{name}}»?"
	},
	"members": {
		"add": "Add members",
		"empty_description": "Add people to start sharing files.",
		"empty_title": "The group is empty",
		"remove": "Remove",
		"removed": "{{name}} is no longer in «{{group}}».",
		"removing": "Removing {{name}}…",
		"search_placeholder": "Search by name or email",
		"undo": "Undo",
		"undo_done": "{{name}} is back in «{{group}}».",
		"undo_failed": "{{name}} could not be put back in the group.",
		"undoing": "Restoring {{name}}…"
	},
	"mine": "My groups",
	"new": {
		"action": "New group",
		"description": "Choose the group's name and visibility.",
		"name": "Name",
		"name_placeholder": "For example, Marketing",
		"name_required": "Enter the group's name.",
		"name_taken": "A group «{{name}}» already exists. Choose another name.",
		"pending": "Creating…",
		"private_note": "This group is private: only its members and the administrators will see it.",
		"submit": "Create group",
		"title": "New group",
		"visibility": "Visibility"
	},
	"page_title": "Groups",
	"search_placeholder": "Search by name",
	"settings": {
		"delete_action": "Delete group",
		"delete_label": "Delete the group",
		"delete_text": "Members will lose access to the files shared with this group. This cannot be undone.",
		"deleted": "Group «{{name}}» deleted.",
		"name": "Name",
		"name_cancel": "Discard the name change",
		"name_confirm": "Confirm the new name",
		"name_help": "The name must be unique in the organization.",
		"renamed": "Group renamed to «{{name}}».",
		"renaming": "Saving the name…",
		"visibility": "Visibility",
		"visibility_fixed": "This group is private: visible only to its members and the administrators. Only an administrator can change its visibility.",
		"visibility_help": "Sets who can find the group and see its members.",
		"visibility_private_done": "The group is now private.",
		"visibility_public_done": "The group is now public.",
		"visibility_saving": "Saving the visibility…"
	},
	"total_one": "{{count}} group",
	"total_other": "{{count}} groups"
}
